import { message } from "antd";
import axiosInstance from "../axiosInstance";
import { PAGE_SIZE } from "../constants";

import {
	FETCH_QUESTIONS_REQUEST,
	FETCH_QUESTIONS_SUCCESS,
	FETCH_QUESTIONS_FAIL,
	UPDATE_QUESTION_REQUEST,
	UPDATE_QUESTION_SUCCESS,
	UPDATE_QUESTION_FAIL,
	FETCH_QUESTION_REQUEST,
	FETCH_QUESTION_SUCCESS,
	FETCH_QUESTION_FAIL,
	CREATE_QUESTION_REQUEST,
	CREATE_QUESTION_SUCCESS,
	CREATE_QUESTION_FAIL,
	DELETE_QUESTION_REQUEST,
	DELETE_QUESTION_SUCCESS,
	DELETE_QUESTION_FAIL,
} from "../constants/question";

const fetchQuestions = (params) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();
	let url = null;
	if (params) {
		url = params.survey_category_id
			? `/admin/questions?page=${params.start}&count=${params.count}&filter[survey_category_id]=${params.survey_category_id}`
			: `/admin/questions?page=${params.start}&count=${params.count}`;
	} else {
		url = "/admin/questions";
	}

	dispatch({ type: FETCH_QUESTIONS_REQUEST });
	try {
		const { data } = await axiosInstance.get(url, {
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});

		dispatch({
			type: FETCH_QUESTIONS_SUCCESS,
			payload: data.data,
		});
	} catch (error) {
		console.log("error: ", error);
		const errorMessage = error.response.data.error;
		dispatch({ type: FETCH_QUESTIONS_FAIL, payload: errorMessage });
	}
};

const updateQuestion = (id, values) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();
	dispatch({ type: UPDATE_QUESTION_REQUEST });
	try {
		const { data } = await axiosInstance.patch(
			`/admin/questions/${id}`,
			values,
			{
				headers: {
					Authorization: "Bearer " + adminInfo.authToken,
				},
			},
		);

		message.success("Updated.");
		dispatch({
			type: UPDATE_QUESTION_SUCCESS,
			payload: data,
		});
	} catch (error) {
		console.log("error: ", error);
		const errorMessage = error.response.data.error;
		message.error(errorMessage);
		dispatch({ type: UPDATE_QUESTION_FAIL, payload: errorMessage });
	}
};

const fetchQuestion = (id) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();
	dispatch({ type: FETCH_QUESTION_REQUEST });

	try {
		const { data } = await axiosInstance.get(`/admin/questions/${id}`, {
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});

		dispatch({ type: FETCH_QUESTION_SUCCESS, payload: data.data });
	} catch (error) {
		console.log("error: ", error);
		const errorMessage = error.response.data.error;
		message.error(errorMessage);
		dispatch({ type: FETCH_QUESTION_FAIL, payload: errorMessage });
	}
};

const createQuestion = (values) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();

	dispatch({ type: CREATE_QUESTION_REQUEST });
	try {
		const { data } = await axiosInstance.post("/admin/questions", values, {
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});
		message.success("Created.");
		dispatch(fetchQuestions({ start: 0, count: PAGE_SIZE }));
		dispatch({
			type: CREATE_QUESTION_SUCCESS,
			payload: data,
		});
	} catch (error) {
		const errorMessage = error.response.data.error;
		message.error(errorMessage);
		dispatch({ type: CREATE_QUESTION_FAIL, payload: errorMessage });
	}
};

const deleteQuestion = (id) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();
	dispatch({ type: DELETE_QUESTION_REQUEST });
	try {
		const { data } = await axiosInstance.delete(`/admin/questions/${id}`, {
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});

		message.success("Deleted.");
		dispatch({
			type: DELETE_QUESTION_SUCCESS,
			payload: data,
		});
	} catch (error) {
		const errorMessage = error.response.data.error;
		message.error(errorMessage);
		dispatch({ type: DELETE_QUESTION_FAIL, payload: errorMessage });
	}
};

export {
	fetchQuestions,
	updateQuestion,
	fetchQuestion,
	createQuestion,
	deleteQuestion,
};
